import {
  DeviceCommandScheduleActions,
  DeviceActionTypes,
} from './device-command-schedule.actions';
import { DeviceCommandScheduleStateInterface } from './device-command-schedule.model';


export const deviceCommandScheduleInitialState: DeviceCommandScheduleStateInterface = {
  page: 1,
  pageCount: 1,
  itemCount: 1,
  itemTotal: 1,
  errors: [],
  filters: null,
  getDeviceCommandScheduleLoading: false,
  getDeviceCommandScheduleLoaded: false,
  deviceCommandScheduleData: [],
};

export function deviceCommandScheduleReducer(state = deviceCommandScheduleInitialState, action: DeviceCommandScheduleActions): DeviceCommandScheduleStateInterface {
  switch (action.type) {
    case DeviceActionTypes.GetDeviceCommandSchedules:
      return {
        ...state,
        getDeviceCommandScheduleLoading: true,
        getDeviceCommandScheduleLoaded: false,
      };
    case DeviceActionTypes.GetDeviceCommandSchedulesCompleted:
      return {
        ...state,
        getDeviceCommandScheduleLoading: false,
        getDeviceCommandScheduleLoaded: true,
        deviceCommandScheduleData: action.messageList,
        itemTotal: action.itemTotal,
      };

    case DeviceActionTypes.ClearState:
      return { ...deviceCommandScheduleInitialState };

    case DeviceActionTypes.FetchError:
      return {
        ...state,
        errors: action.payload,
      };

    default:
      return state;
  }
}
